import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import configjson from '../config.json';
import {
  newUser,
  IApiCallStatus,
  useAlertContext,
  useUserContext,
  mapUserAuthenticated,
} from '../common';
import { always } from 'rambda';
import { fold, left, right, map as emap } from 'fp-ts/lib/Either';
import { compose as lcompose } from 'lodash/fp';

interface GenerateUserProps {
  code: string;
}

export function GenerateUser({ code }: GenerateUserProps) {
  let history = useNavigate();

  const [apiCallStatus, setApiCallStatus] = useState<IApiCallStatus>();
  const [message, setMessage] = useState('');
  const { setUser } = useUserContext();

  useEffect(() => {
    const run = lcompose(
      () => setApiCallStatus(null),

      code =>
        newUser(code).then(
          fold<void, string, void>(
            () => setApiCallStatus(false),
            lcompose(() => setApiCallStatus(true), setMessage)
          )
        )
    );

    lcompose(emap(run), code => (code === '' ? left(code) : right(code)))(code);
  }, [code]);

  const { setAlert } = useAlertContext();

  useEffect(() => {
    switch (apiCallStatus) {
      case null:
        setAlert(a => ({
          ...a,
          title: '',
          message: () => (
            <>
              <FontAwesomeIcon icon={faSpinner} size="1x" fixedWidth spin />{' '}
              {configjson.generateUser}
            </>
          ),
          okAction: false,
          cancelAction: false,
          isOpen: true,
        }));
        break;

      case true:
        setAlert(a => ({
          ...a,
          title: '',
          message: () => <b>{message}</b>,
          okAction: true,
          cancelAction: false,
          isOpen: true,
          ackCheckBox: true,
        }));
        break;

      case false:
        setAlert(a => ({
          ...a,
          title: '',
          message: () => <b>account create error.</b>,
          okAction: true,
          cancelAction: false,
          isOpen: true,
        }));
        break;

      default:
        break;
    }
  }, [apiCallStatus, message, setAlert]);

  useEffect(() => {
    lcompose(
      emap(
        lcompose(
          setUser,
          always(mapUserAuthenticated(false)),

          () => history('/')
        )
      ),
      apiCallStatus => (apiCallStatus === false ? right(void 0) : left(void 0))
    )(apiCallStatus);
  }, [apiCallStatus, setUser, history]);

  return <></>;
}
